var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"optionCirclie",style:({
    width: '100%',
    height: '400px',
    background: '#F9F9F9',
    borderRadius: '14px',
  })})}
var staticRenderFns = []

export { render, staticRenderFns }